export function deploymentLine(line: string): string | undefined {
  let message = line
  try {
    const parsed = JSON.parse(line) as Record<string, unknown>
    const jsonMessage = parsed.message ?? parsed.status
    if (typeof jsonMessage === 'string') message = jsonMessage
  } catch {
    // Non-JSON Railway output is already suitable for the spinner.
  }
  // Railway's JSON events carry raw build-log tabs, which render wider than the one column clack's
  // spinner width math counts, wrapping its animated dots onto the next terminal row.
  message = message.replace(/\s+/g, ' ').trim()
  return message === '' || /^\.+$/.test(message) ? undefined : message.slice(0, 140)
}
